module.exports = __webpack_public_path__ + "static/01c533a21c54c1b57bf7d057f05d66621ab667ba5fae8f6fcd12c6ea021506b9-06acf77f6151cc10f0837d476f7f9ca3.png";